import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const Grid = styled.div`
  display: grid;
  grid-auto-flow: row;
  row-gap: 8px;
`;

function Label({ label, children }) {
  return (
    <Grid>
      {label}
      {children}
    </Grid>
  );
}

Label.propTypes = {
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default Label;
